import React from 'react';
import { Ring } from "@uiball/loaders";

const LoadingIndicator: React.FC = () => (
    <Ring
        size={40}
        lineWeight={5}
        speed={2}
        color="244E22"
    />
);

export default LoadingIndicator;
